
import ChannelSingleton from './ChannelsSingleton';
import store from './../../store';
import {
    showModal,
    MODAL_FILTERS_LIVE_CATEGORIES,
    MODAL_FILTERS_LIVE,
    MODAL_OPTIONS_EVENT
} from '../../actions/modal';
import { playFullMedia } from '../../actions/playmedia';
import AAFPlayer from "../../AAFPlayer/AAFPlayer";
import DeviceStorage from '../DeviceStorage/DeviceStorage';
import Assets from '../../requests/apa/Asset';
import Translator from '../../requests/apa/Translator';
import LoadFav from '../../AAF/LoaderExp/LoadFav';
import { showNotFavoriteChannels } from '../../actions/notification';
import { setMetricsEvent } from '../../actions/metrics';
import AnalyticsDimensionSingleton from '../Header/AnalyticsDimensionSingleton';
import { LIVE_PLAY_FROM_MOSAIC } from '../../AAFPlayer/helpers/ThirdPartyEpgHelper';
import Utils from "../../utils/Utils";

let hideEpgOutside = null;

const setHideEpgOutside = (cb) => {
    hideEpgOutside = cb;
}

const sendMetric = (label) => {
    if (typeof setMetricsEvent === 'function') {
        store.dispatch(
            setMetricsEvent({
                hitType: 'event',
                eventCategory: 'guia de programacion',
                eventAction: `click`,
                eventLabel: label
            })
        );
        store.dispatch(setMetricsEvent({ type: 'executor' }));
        sendDimension();
    }
}

const sendDimension = () => {
    const payload = new AnalyticsDimensionSingleton().getPayload();
    store.dispatch(setMetricsEvent(payload));
    store.dispatch(setMetricsEvent({ type: 'executor' }));
}

const dispatchPlayMedia = (group_id, filterTV) => {
    store.dispatch(playFullMedia({
        playerstate: 'PLAYING',
        source: {
            videoid: group_id
        },
        ispreview: false,
        islive: true,
        size: {
            top: 0,
            left: 0,
            width: 1280,
            height: 720,
        },
        ispip: false,
        showEpg: !!filterTV,
        filterTV: filterTV,
        event: null,
        playFromCard: true
    }));
};

const handleChangeChannel = (channel) => {
    const { group_id = null } = channel;
    group_id && hideEpgOutside && (typeof hideEpgOutside === 'function') && hideEpgOutside(group_id, null, LIVE_PLAY_FROM_MOSAIC);
}

const handleBack = ({ ...data }) => {
    const { hideEpgOutsideCb = null, handleGuideCb = null } = data;
    redHandler({ hideEpgOutsideCb, handleGuideCb });
}

const handleExit = () => {
}

const showGridChannels = ({ ...data }) => {
    const { handleGuideCb = null, isFromKey = false } = data;

    // MODAL PARA MOSTRAR GRILLA DE CANALES
    new ChannelSingleton().getFilters().then(resp => {
        if (Array.isArray(resp) && resp[0] && resp[0].id) {
            new ChannelSingleton().getFilteredChannels(resp[0].id).then((channels) => {
                const modal = {
                    modalType: MODAL_FILTERS_LIVE_CATEGORIES,
                    modalProps: {
                        filters: channels,
                        isFromKey,
                        title: Translator.get('channelSelector_modal_title_label', 'Canales'),
                        onClick: handleChangeChannel,
                        handleBack: () => { handleBack({ handleGuideCb }) },
                        handleExit: handleGuideCb,
                    }
                }
                store.dispatch(showModal(modal));
            });
        }
    });
}

const handleChangeFilter = (filter, filters, filterFav = false) => {
    let IdFilter = (filter && filter.id) || null;
    let filterGroupid = null;
    IdFilter && new ChannelSingleton().getFilteredChannels(IdFilter).then(async (availableChannels) => {
        if (availableChannels && Array.isArray(availableChannels) && availableChannels[0] && availableChannels[0].group_id) {
            filterGroupid = availableChannels[0].group_id;
            const currentPlayerOptions = AAFPlayer.getCurrentPlayerOptions();
            if (currentPlayerOptions.playerstate === 'PLAYING' && currentPlayerOptions.islive && !currentPlayerOptions.hasOwnProperty('audiosource')) {
                filterGroupid = currentPlayerOptions.source && currentPlayerOptions.source.videoid ? currentPlayerOptions.source.videoid : filterGroupid;
            }
        }
        if (filters && Array.isArray(filters)) {
            if (filterFav) {
                // SI ES EL FILTRO DE FAVORITOS
                IdFilter = filterFav.id;
                IdFilter = filters.findIndex(el => el.id == IdFilter);
                if (LoadFav.isEmpty()) {
                    //Si no hay canales favoritos, se manda la notificación.
                    IdFilter = 0;
                    store.dispatch(showNotFavoriteChannels());
                }
                if (typeof IdFilter === 'number') {
                    IdFilter = IdFilter.toString();
                }
            } else {
                IdFilter = filters.findIndex(el => el.id == IdFilter);
                if (filters[IdFilter]) {
                    const current = filters[IdFilter];
                    IdFilter = IdFilter.toString();
                    if (current && current.text) {
                        sendMetric(current.text);
                    }
                }
            }
        }
        IdFilter && filterGroupid && dispatchPlayMedia(filterGroupid, IdFilter);
    });
}

const showModalCategories = ({ ...data }) => {
    const region = DeviceStorage.getItem('region');

    const { handleGuideCb = null } = data;

    // MODAL PARA MOSTRAR LOS FILTROS DE CANALES.
    new ChannelSingleton().getFilters().then(filters => {
        let allCategories = getNormalFilters(filters);

        allCategories = allCategories && Array.isArray(allCategories) && allCategories.map(filter => {
            const keyImage = `${region || ''}_playingLive_access_button_${filter.code || ''}`;
            filter.image = Assets.get(keyImage, '/images/placeholder_landscape.png');
            return filter;
        });

        const modal = {
            modalType: MODAL_FILTERS_LIVE_CATEGORIES,
            modalProps: {
                filters: allCategories,
                title: Translator.get('categorieSelector_modal_title_label', 'Seleccioná una categoría'),
                onClick: (filter) => handleChangeFilter(filter, allCategories),
                handleBack: () => { handleBack({ handleGuideCb }) },
                handleExit
            }
        }
        store.dispatch(showModal(modal));
    });
}

const getNormalFilters = (filters = []) => {
    return filters && Array.isArray(filters) && filters.filter(filter => {
        return !filter.isFavorite
    }) || [];
}

const handleFavorites = () => {
    // FUNCION QUE OBTIENE EL LISTADO DE CANALES FAVORITOS.
    new ChannelSingleton().getFilters().then(filters => {
        const filterFav = filters && Array.isArray(filters) && filters.find(el => el.isFavorite);
        // const allCategories = getNormalFilters(filters);
        if (filters && Array.isArray(filters)) {
            handleChangeFilter(filters[0], filters, filterFav);
        }
    })
}

const showModalOptionsEventDefault = (modalData) => {
  const modal = {
    modalType: MODAL_OPTIONS_EVENT,
    modalProps: modalData
  };
  store.dispatch(showModal(modal));

};

const showModalOptionsEventPS4 = (modalData) => {
  setTimeout(() => showModalOptionsEventDefault(modalData), 100);
};

const blueHandler = ({ ...dataModal }) => {
    const {
      hideEpgOutsideCb = null,
      data, streamType = null,
      streamContentType = null,
      changeLangCb = null,
      keyFrom = null,
      from = null,
      showFullEpg = null,
      onClose =() =>{}} = dataModal;
    // Ejecutando hideEpgOutside
    hideEpgOutsideCb && (typeof hideEpgOutsideCb === 'function') && hideEpgOutsideCb();
    const isPS4 = Utils.isPlaystation4()
    const modalData = {
      data,
      streamType,
      streamContentType,
      changeLangCb,
      keyFrom,
      from,
      showFullEpg,
      onClose
    }

    isPS4 ? showModalOptionsEventPS4(modalData) : showModalOptionsEventDefault(modalData);

}

const redHandler = ({ ...data }) => {
    const { hideEpgOutsideCb = null, handleGuideCb = null } = data;
    const { user = {} } = store.getState();
    const userHasButtonFav = !(user && user.isAnonymous || false);

    // Ejecutando hideEpgOutside
    hideEpgOutsideCb && (typeof hideEpgOutsideCb === 'function') && hideEpgOutsideCb();
    const modal = {
        modalType: MODAL_FILTERS_LIVE,
        modalProps: {
            buttonsBody: [{
                title: Translator.get('filterSelector_modal_option_button_categorieSelector', 'Categorías'),
                onClick: () => {
                    sendMetric('categoria');
                    showModalCategories({ handleGuideCb })
                }
            },
            {
                title: Translator.get('filterSelector_modal_option_button_channelSelector', 'Canales'),
                onClick: () => {
                    sendMetric('canales');
                    showGridChannels({ handleGuideCb })
                }
            },
            userHasButtonFav ? {
                title: Translator.get('filterSelector_modal_option_button_favoritesSelector', 'Canales favoritos'),
                onClick: () => {
                    sendMetric('favoritos');
                    handleFavorites({ handleGuideCb })
                }
            } : null
            ],
            buttonsFooter: [
                {
                    title: Translator.get('top_head_option_button_exit', 'SALIR'),
                    onClick: () => {
                        sendMetric('salir');
                    },
                    color: 'green'
                },
                {
                    title: Translator.get('top_head_option_button_return', 'REGRESAR'),
                    onClick: () => {
                        handleGuideCb()
                    },
                    image: Assets.get('top_head_option_back', ''),
                    color: 'yellow'
                }
            ],
            title: Translator.get('filterSelector_modal_title_label', 'Filtrar'),
            yellowRCU: () => {
                handleGuideCb()
            },
            color: 'red'
        }
    };
    store.dispatch(showModal(modal));
}

const ModalEpgUtils = {
    showGridChannels,
    showModalCategories,
    redHandler,
    blueHandler,
    setHideEpgOutside
};

export default ModalEpgUtils;



// WEBPACK FOOTER //
// ./src/components/Epg/ModalEpgUtils.js